import React from 'react';
import { array, func, object, string } from 'prop-types';

import { useTranslate } from '../../translate/I18n';

import Button from '../atoms/Button';
import CollapsibleWithSwitch from '../elements/CollapsibleWithSwitch';
import SanitizedHTML from '../elements/SanitizedHTML';
import { FormProvider, useForm } from 'react-hook-form';

const CookieField = ({ name, t, formHook, initialValues }) => (
  <div className="bg-light ph-sesqui pv mb">
    <CollapsibleWithSwitch
      title={t(`cookiesPolicy:${name}.title`)}
      description={t(`cookiesPolicy:${name}.content`)}
      hasSwitch={true}
      switchName={name}
      toggleLabel={t(`cookiesPolicy:${name}.exampleLabel`)}
      formHook={formHook}
      initialValues={initialValues}
    >
      <SanitizedHTML content={t(`cookiesPolicy:${name}.example`)} />
    </CollapsibleWithSwitch>
  </div>
);

CookieField.propTypes = {
  name: string,
  t: func,
  formHook: object,
  initialValues: object
};

const CookiePolicyForm = ({ cookies, initialValues, updateCookies }) => {
  const { t } = useTranslate(['cookiesPolicy']);

  const formHook = useForm();
  const { register, handleSubmit } = formHook;

  return (
    <FormProvider {...formHook}>
      <form onSubmit={handleSubmit(updateCookies)} noValidate>
        <div className="bg-light ph-sesqui pv mb">
          <CollapsibleWithSwitch
            formHook={formHook}
            title={t('cookiesPolicy:technicalCookies.title')}
            description={t('cookiesPolicy:technicalCookies.content')}
            hasSwitch={false}
            toggleLabel={t('cookiesPolicy:technicalCookies.exampleLabel')}>
            <SanitizedHTML content={t('cookiesPolicy:technicalCookies.example')} />
          </CollapsibleWithSwitch>
        </div>
        {cookies.map(cookie => (
          <CookieField key={cookie} name={cookie} t={t} formHook={formHook} initialValues={initialValues}/>
        ))}
        <div className="t-center">
          <Button type="submit" className="btn-lg mt m-auto block">
            {t('cookiesPolicy:saveMyPreferences')}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

CookiePolicyForm.propTypes = {
  cookies: array,
  initialValues: object,
  updateCookies: func
};

export default CookiePolicyForm;
